<template>
    <div class="container mt-5">
     <div class="card text-center floating-card ">

    
      <h4 class="floating-content">Distribución por Género</h4>

    <template>
    <div class="tamaño mx-auto">
      <apexchart width="360"   type="donut" :options="options" :series="series"></apexchart>
    </div>
  </template>
</div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { BASE_URL } from '../store/config';
 
  
  export default {
    data() {
      return {
        niños: [],
        errorLoadingNiños: null,
        options: {
        },
      };
    },
    computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
},
    methods: {
      loadNiños() {
        axios
          .get(`${BASE_URL}/api/nino`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          })
          .then(response => {
            this.niños = response.data;
            this.actualizarGrafico();
          })
          .catch(error => {
            this.errorLoadingNiños = 'Error al cargar niños. Por favor, inténtalo de nuevo.';
            console.error('Error al cargar niños:', error);
          });
      },
      actualizarGrafico() {
        // Contar niños por género
        const countMale = this.niños.filter(niño => niño.sexo === 'MASCULINO').length;
        const countFemale = this.niños.filter(niño => niño.sexo === 'FEMENINO').length;
        
       this.options = {
        colors: ["#36A2EB", "#FF6384"],
     
        series: [countMale, countFemale],
         labels: ['MASCULINO', 'FEMENINO']
            }

       
      },
    },
    mounted() {
      this.loadNiños();
    },
  };
  </script>
  
  <style>
   
  
 .floating-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
    transition: box-shadow 0.3s ease-in-out;
  }
  
  .floating-content {
    transform: translate3d(0, -5px, 0);
    transition: transform 0.3s ease-in-out;
  }

 

  

   
  </style>
  